<template>
    <div
        class="meterial-box"
        :class="{
            'deep-black': true,
            isWordAudio
        }"
    >
        <div v-if="!isWordAudio" class="title">素材库</div>
        <div class="type-box" v-if="this.type!=='gameScenes'">
            <el-radio-group
                    size="small"
                    v-model="activeName"
                    @change="handleSelectType">
                <el-radio-button  v-if="isWordAudio" :label="'AI语音合成'"></el-radio-button>
                <el-radio-button :label="type==='game'?'公共游戏':'公共模式'"></el-radio-button>
                <el-radio-button v-if="isMine && !isTemplateShop && !['game', 'tools'].includes(this.type)" :label="type==='game'?'C端游戏':'我的'"></el-radio-button>
            </el-radio-group>
        </div>
        <TypeList
            v-if="!isWordAudio"
            :data="typeListData"
            :select.sync="newType"
        />

        <div
                class="right-content"
        >
        <div class="type-select-box"
             v-if="type !== 'gameScenes' && ['0', '1'].includes(`${$enums.enumTypeName[activeName]}`)">
            <TypeSelect
                v-if="!isTemplateShop"
                v-show="`${$enums.enumTypeName[activeName]}` === '0'"
                :isShow="`${$enums.enumTypeName[activeName]}` === '0'"
                :type="type"
                :api-config="{
                   add: apiConfig.addResourceCategoryOne,
                   delete: apiConfig.deleteResourceCategoryOne,
                   update: apiConfig.updateResourceCategoryOne,
                   select: apiConfig.getResourceCategoryTreeOne
                }"
                    :data.sync="typeSelectDataMe"
                    @onTypeSelect="onTypeSelectOne"
            />
            <TypeSelect
                v-show="`${$enums.enumTypeName[activeName]}` === '1'"
                :isShow="`${$enums.enumTypeName[activeName]}` === '1'"
                :categoryId="newCId"
                :type="type"
                :api-config="{
                   add: apiConfig.addResourceCategoryTwo,
                   delete: apiConfig.deleteResourceCategoryTwo,
                   update: apiConfig.updateResourceCategoryTwo,
                   select: apiConfig.getResourceCategoryTreeTwo
                }"
                :data.sync="typeSelectData"
                @onTypeSelect="onTypeSelectTwo"
            />
        </div>
        <MusicItem
            ref="music"
            v-if="newType === 'audio' && ['0', '1'].includes($enums.enumTypeName[activeName])"
            :isCocos="isCocos"
            :isAuto="isAuto"
            :loading.sync="loading"
            :isShop="isTypeTwo"
            :isWordAudio="isWordAudio"
            :isEdit="isEdit"
            :curEditItem="curEditItem"
            :categoryId.sync="categoryId"
            :type="newType"
            :data.sync="musicData"
            :pageConfig.sync="pageConfig"
            @onSelect="onSelect"
            @success="$emit('success')"
            @onFlash="flashData"
            @onPage="onPage"
            @batchUpload="batchUpload"
            @onWordAudio="onWordAudio"
            @onChanageTab="onChanageTab($event, 'music')"
        />
        <MaterialItem
            v-else-if="!isWordAudio && ['0', '1'].includes($enums.enumTypeName[activeName])"
            ref="other"
            :isCocos="isCocos"
            :loading.sync="loading"
            :type="type"
            :isAdd.sync="addAuth"
            :isShop="isTypeTwo"
            :isShow="isShow"
            :data.sync="materialData"
            :pageConfig.sync="pageConfig"
            :catelog.sync="newCatalog"
            :class="{'scenes': type === 'gameScenes'}"
            @onMaterialItem="onMaterialItem"
            @onMaterialItemAdd="onMaterialItemAdd"
            @onPage="onPage"
            @batchAdd="batchUpload"
            @onBackground="onBackground"
            @onChanageTab="onChanageTab($event, 'other')"
        />

            <AiSelect
                    v-else
                    ref="roles"
                    :is-content="true"
                    :is-file-name="true"
                    :defaultValue="{text: selfFlag.content}"
                    @success="$emit('success')"
                    @onXunfei="onXunfei"
            />
        </div>
        <IMForm
            v-if="isBatch"
            ref="batch"
            title="批量上传"
            width="1000px"
            :loading="loading"
            :type.sync="type"
            :isPlat.sync="isTypeTwo"
            :visible.sync="isBatch"
            :form.sync="uploadBatchFields"
            :isSelfClose="true"
            @success="onBatchUpload"
        />
        <Form
            v-if="isAdd"
            :type.sync="type"
            :visible.sync="isAdd"
            :isPlat="isPlat"
            :defaultValue="defaultFormValue"
            @success="flashData"
        />
        <WarnInfo
            :isWarnInfo.sync="isWarnInfo"
            :loading.sync="isLoadingSubmit"
            :type="type"
            @success="submit"
        />
    </div>
</template>

<script>
    import BMF from 'browser-md5-file';
    import {mapState, mapActions} from 'vuex';
    import TypeList from './components/typeList';
    import TypeSelect from './components/typeSelect';
    import MaterialItem from './components/materialItem';
    import MusicItem from './components/musicItem';
    import Form from '../../views/main/components/types/components/common/components/uploadBtn/components/form';
    import WarnInfo from '../../views/main/components/types/components/common/components/typeList/components/warnInfo';
    import AiSelect from '../../components/VoiceConfig/components/roles/aiSelect';
    import { getRandomByObj } from "../../utils/utils";
    import {upLoad, getFileStream} from "../../utils/upload";
    import {AudioPlay2} from "../../utils/audio";
    import * as CommonServer from "../../api/common";
    import * as FormServer from '../../api/form';
    import { filedsBatch } from './components/materialItem/fields';
    import * as ResultServer from '../../api/resource'
    export default {
        name: "material",
        components: {
            TypeList,
            TypeSelect,
            MaterialItem,
            MusicItem,
            Form,
            AiSelect,
            WarnInfo
        },
        props: {
            filterValue: String, // 游戏/工具 筛选过滤条件
            activeIndex: String,
            isCocos: {
                type: Boolean,
                default: false
            },
            isAuto: {
                type: Boolean,
                default: true
            },
            isEdit:{
                type: Boolean,
                default: false
            },
            curEditItem: Object,
            newCategoryId: [String, Number],
            type: String,
            search: String,
            catalog: [String, Number],
            // 是否支持回调
            isCallBack: {
                type: Boolean,
                default: false
            },
            callBack: Object,
            // 导航id
            navId: [String, Number],
            // 文音组件
            isWordAudio: {
                type: Boolean,
                default: false
            },
            // 自定义配置
            selfFlag: Object,
            // // 是否启用 文音组件
            // isOpen: {
            //     type: Boolean,
            //     default: true
            // }
        },
        computed: {
            ...mapState(['menusData', 'menusDataIds']),
            batchData () {
                let arr = []
                try {
                    arr = this.isTypeTwo
                        ? this.typeSelectData
                        : this.typeSelectDataMe
                } catch (e) {
                    console.log('batchData==>', e)
                }
                return arr
            },
            // 当前页容量
            curPageSize(){
                let hasBatchAdd = ['audio'].includes(this.type)?8:18
                let noAdd = 18
                return this.addAuth?hasBatchAdd:noAdd
            },
            addAuth:{
                get()
                {
                    let state = false
                    // 获取权限
                    let isShop = this.$store.getters.isPlat
                    switch (this.type) {
                        case 'scenes':
                            state = isShop ? this.$store.state.permissions['meterial_scene_shop_add'] : this.$store.state.permissions['meterial_scene_my_add']
                            break
                        case 'image':
                            state = isShop ? this.$store.state.permissions['meterial_image_shop_add'] : this.$store.state.permissions['meterial_image_my_add']
                            break
                        case 'audio':
                            state = isShop ? this.$store.state.permissions['meterial_audio_shop_add'] : this.$store.state.permissions['meterial_audio_my_add']
                            break
                        case 'animation':
                            state = isShop ? this.$store.state.permissions['meterial_animate_shop_add'] : this.$store.state.permissions['meterial_animate_my_add']
                            break
                        case 'video':
                            state = isShop ? this.$store.state.permissions['meterial_video_shop_add'] : this.$store.state.permissions['meterial_video_my_add']
                            break
                        default:
                    }
                    return state
                },
                set(){

                }
            },
            authConfig () {
                let catalog = ''
                let shopCatalog = ''
                switch (this.type) {
                    case 'template':
                        catalog = this.$store.state.permissions['meterial_template_my_catalog']
                        shopCatalog = this.$store.state.permissions['meterial_template_shop_catalog']
                        break
                    case 'scenes':
                        catalog = this.$store.state.permissions['meterial_scenes_my_catalog']
                        shopCatalog = this.$store.state.permissions['meterial_scenes_shop_catalog']
                        break
                    case 'image':
                        catalog = this.$store.state.permissions['meterial_image_my_catalog']
                        shopCatalog = this.$store.state.permissions['meterial_image_shop_catalog']
                        break
                    case 'audio':
                        catalog = this.$store.state.permissions['meterial_audio_my_catalog']
                        shopCatalog = this.$store.state.permissions['meterial_audio_shop_catalog']
                        break
                    case 'animation':
                        catalog = this.$store.state.permissions['meterial_animate_my_catalog']
                        shopCatalog = this.$store.state.permissions['meterial_animate_shop_catalog']
                        break
                    case 'video':
                        catalog = this.$store.state.permissions['meterial_video_my_catalog']
                        shopCatalog = this.$store.state.permissions['meterial_video_shop_catalog']
                        break
                    case 'game':
                    case 'tools':
                        catalog = this.$store.state.permissions['meterial_game_my_catalog']
                        shopCatalog = this.$store.state.permissions['meterial_game_shop_catalog']
                        break
                }
                return {
                    catalog,
                    shopCatalog, // 公共
                }
            },
            // 是否是公共模版
            isTemplateShop () {
                let state = false
                if (`${this.$route.query.is_template}` === 'true' && `${this.$route.query.is_shop}` === 'true') {
                    state = true
                }
                return state
            },
            isPlat() {
                return `${this.$enums.enumTypeName[this.activeName]}` === '1'
            },
            getFormList(){
                return this.isPlat?'getFormList':'getFormList'
            },
            addResource(){
                return `${this.$store.state.initConfig.school_id}` === '-1'?'addResourceShop':'addResource'
            },
        },
        watch:{
            activeName:{
                handler(vl) {
                    this.$emit('update:activeIndex', vl)
                },
                deep: true,
                immediate: true
            },
            type(vl) {this.newType = vl;},
            newCategoryId(vl) {this.newCId = vl;},
            newType(vl) {this.$emit('update:type', vl);},
            search(vl) {this.newSearch = vl;},
            newSearch() {
                this.flashData()
            },
            filterValue(vl) {this.newFilterValue = vl;},
            newFilterValue() {
                this.flashData()
            },
            catalog: {
                handler(vl){
                    this.newCatalog = vl;
                    this.flashData()
                },
                deep: true,
                immediate: true
            },
            newCatalog(vl) {
                this.$emit('update:catalog', vl);
            }
        },
        created(){
            this.$nextTick(()=>{
                if(this.isWordAudio) {
                    this.activeName = 'AI语音合成'
                }
            })
            this.isMine=(this.categoryId)?0:1;
            this.isShow=(this.categoryId)?false:true;
        },
        data(){
            return {
                isWarnInfo: false, // 确认弹窗
                isLoadingSubmit: false, // 当前是否正在确认
                fnNext: null, // 当确认点击后需要执行的事件回调

                isAdd: false, // 添加
                activeName: '公共模式', // 公共 或 我的

                newCatalog: this.catalog,
                // 分页
                pageConfig: {
                    page: 1,
                    pageSize: this.curPageSize,
                    total: 1
                },
                loading: false,
                categoryId: null,
                isShow:true,
                isMine:true,
                isSceneShow: false, // 是否场景展示
                isTypeTwo: true, // 当前是否商城
                newSearch: this.search, // 搜索内容
                newFilterValue: this.filterValue, // 游戏/工具 过滤条件
                apiConfig: ['game', 'tools'].includes(this.type)?{
                    getResourceCategoryTreeOne: 'getGameCategoryTree',
                    getResourceCategoryTreeTwo: 'getGameCategoryTreeDouble',
                    addResourceCategoryOne: 'addGameCategory',
                    addResourceCategoryTwo: 'addGameCategoryDouble',
                    deleteResourceCategoryOne: 'deleteGameCategory',
                    deleteResourceCategoryTwo: 'deleteGameCategory',
                    updateResourceCategoryOne: 'updateGameCategory',
                    updateResourceCategoryTwo: 'updateGameCategory',
                    getResourceListOne: 'getGameList',
                    getResourceListTwo: 'getGameList',
                    addResourceOne: 'addGame',
                    addResourceTwo: 'addGame'
                }:{
                    getResourceCategoryTreeOne: 'getResourceCategoryTree', // 第一块分类树
                    getResourceCategoryTreeTwo: 'getResourceCategoryShopTree', // 第二块分类树
                    addResourceCategoryOne: 'addResourceCategory', // 添加第一块分类
                    addResourceCategoryTwo: 'addResourceCategoryShop', // 添加第二块分类
                    deleteResourceCategoryOne: 'deleteResourceCategory', // 删除第一块分类
                    deleteResourceCategoryTwo: 'deleteResourceCategoryShop', // 删除第二块分类
                    updateResourceCategoryOne: 'updateResourceCategory', // 更新第一块分类
                    updateResourceCategoryTwo: 'updateResourceCategoryShop', // 更新第二块分类
                    getResourceListOne: 'getResourceList', // 获取第一块分类中的所有资源
                    getResourceListTwo: 'getResourceShopList', // 获取第二块分类中的所有资源
                    addResourceOne: 'addResource', // 添加第一块分类中的资源
                    addResourceTwo: 'addResourceShop', // 添加第二块分类中的资源
                    addBatchResourceOne: 'addBatchResource', // 批量添加第一块分类中的资源
                    addBatchResourceTwo: 'addBatchResourceShop', // 批量添加第二块分类中的资源
                },
                newCId: this.newCategoryId,
                newType: this.type,
                typeListSelect: '',
                // ['template','scemes','word','image','audio','animation','video','game','me']
                typeListData: [
                    {id: 0, type: 'template', name: '模式'},
                    {id: 1, type: 'scemes', name: '场景'},
                    {id: 2, type: 'word', name: '文字'},
                    {id: 3, type: 'image', name: '图片'},
                    {id: 4, type: 'audio', name: '音频'},
                    {id: 5, type: 'animation', name: '动画'},
                    {id: 6, type: 'video', name: '视频'},
                    {id: 7, type: 'game', name: '游戏'},
                    {id: 8, type: 'gameScenes', name: '游戏场景'},
                    ],
                typeSelectDataMe: [
                    {
                        id: 1,
                        name: '所有分类',
                        delete: true
                    }
                ],
                typeSelectData: [
                    {
                        id: 1,
                        name: '所有分类',
                        delete: true
                    }
                ],
                materialData: [
                    // {id: 1, url: '', eyes: false},
                    // {id: 2, url: '', eyes: true},
                    // {id: 2, url: '', eyes: true},
                    // {id: 2, url: '', eyes: true},
                    // {id: 2, url: '', eyes: true},
                    // {id: 2, url: '', eyes: true},
                    // {id: 2, url: '', eyes: true},
                    // {id: 2, url: '', eyes: true},
                    // {id: 2, url: '', eyes: true},
                    // {id: 2, url: '', eyes: true},
                ],
                musicData: [
                    // {id: 1, url: 'https://yunkedun-school-1-1254009145.cos.ap-guangzhou.myqcloud.com/037614f4cbcb8c5c7410bb94e8366cd2.mp3', name: '红豆asdfasdfasdfasdfasdfasdf', play: false, love: false},
                    // {id: 2, url: '', name: '红豆1', play: true, love: true},
                    // {id: 3, url: '', name: '红豆2', play: false, love: false},
                    // {id: 4, url: '', name: '红豆3', play: false, love: false},
                ],
                // 上传默认值
                defaultFormValue: {
                    categoryId: []
                },
                uploadBatchFields: this.$_.cloneDeepWith(filedsBatch),
                isBatch: false // 批量上传
            }
        },
        methods: {
            ...mapActions(['setOperationQueue']),
            init () {
                // this.getMyTempType()
                // this.getShopTempType()
                // this.getNavsList()
            },
            practiceBool(){
                return `${this.$route.query.is_practice}` === 'true'
            },
            submit(){
                const fn = setTimeout(()=>{
                    if(this.fnNext) {
                        this.fnNext()
                        this.fnNext = null
                    }
                    this.isLoadingSubmit = false
                    this.isWarnInfo = false
                    clearTimeout(fn)
                }, 100)
            },
            // 播放音频
            handlePlayAudio(){
                if(this.selfFlag?.audioSrc) {
                    AudioPlay2({url: this.selfFlag.audioSrc})
                }
            },
            onXunfei(obj){
                console.log('AI语音合成成功==>', obj)
                // 1.向cocos发出AI合成配置 音频路径、音频名称、是否启用
                if (!obj.url) return false
                this.uploadAudio({url: obj.url, type: 'ai', name: obj.fileName})
            },
            // 将远端地址转成文件流上传
            uploadAudio({url, type, name}) {
                // 将合成音频上传至音频素材
                // 1.将远端地址转成文件流
                // 2.将文件流上传到腾讯云
                // 3.上传合成音频到素材
                getFileStream({url, name, callback: (blob)=>{
                        const bmf = new BMF()
                        bmf.md5(blob, (err, md5)=>{
                            upLoad({isPlat: `${this.$store.state.initConfig.school_id}` === '-1', fileName: `${md5}.mp3`, file: blob, callback: async url=>{
                                    let newName = type === 'wx'?'微信':'合成'+'音频' + md5.slice(0,3)
                                    if(name) {
                                        newName = name
                                    }
                                    // 上传音频文件到素材列表
                                    let newUrl = this.$utils.getHtmlMd5(url)
                                    const remotepath = url.split('.com/')[1]
                                    let obj = {
                                        clientsId: this.$store.state.initConfig.school_id,
                                        sort: this.type,
                                        name: newName,
                                        alias: '',
                                        attributes: {
                                            cover: url,
                                            remotepath,
                                            md5: newUrl.indexOf('.') > -1?newUrl.split('.')[0] : newUrl
                                        }
                                    }

                                    const res = await CommonServer.default[this.addResource](obj)
                                    if (`${res.status_code}` === '200') {
                                        this.onWordAudio({
                                            audioName: newName,
                                            audioSrc: url
                                        })
                                        this.$emit('success')
                                    } else {
                                        // this.$message.error('上传失败')
                                    }

                                }})
                        })

                    }})
            },
            // 文音组件选中音频回调
            onWordAudio(obj){
                const {audioName, audioSrc} = obj
                if(['AudioSelect'].includes(this.selfFlag.type)) {
                    this.toCocosEditConfig({
                        audioName,
                        audioSrc
                    }, 'name', 'value')
                }
                if(['AudioWord'].includes(this.selfFlag.type)) {
                    this.toCocosEditConfig({
                        audioName,
                        audioSrc
                    }, 'audioName', 'audioSrc')
                }
            },
            // 向cocos通知修改文音组件/音频组件
            toCocosEditConfig(obj, name, src){
                const callBack = this.$_.cloneDeepWith(this.callBack)

                // 编辑游戏替换素材
                if(callBack){
                    let operationQueue = [
                        {
                            id: callBack.id,
                            operation: callBack.operation,
                            path: callBack.path + '/' + name,
                            data: obj.audioName
                        },
                        {
                            id: callBack.id,
                            operation: callBack.operation,
                            path: callBack.path + '/' + src,
                            data: obj.audioSrc
                        }
                    ]
                    this.setOperationQueue(operationQueue)
                    return false
                }
                this.$emit('success')
            },
            // 音频手动切换 当前用户权限的类型
            onChanageTab(methodName, refName){
                // 1.如果当前是校区账号 且 在公共类型中则上传任意按钮后
                // 2.先切换到当前校区类型
                // 3.再弹出上传页面
                const isPlat = this.$store.getters.isPlat
                if(isPlat){
                    this.activeName = this.type === 'game'? '公共游戏':'公共模式'
                } else{
                    this.activeName = this.type === 'game'? 'C端游戏':'我的'
                }
                this.handleSelectType()
                console.log(methodName)
                this.$nextTick(()=>{
                    const fn = setTimeout(()=>{
                        this.$refs[refName] &&
                        this.$refs[refName][methodName] &&
                        this.$refs[refName][methodName]()

                        clearTimeout(fn)
                    }, 500)
                })
            },
            // 选择公共或我的
            handleSelectType () {
                console.log('选中大分类==>', this.activeName)
                if (['公共游戏','公共模式'].includes(`${this.activeName}`)) {
                    this.isTypeTwo = true
                } else {
                    this.isTypeTwo = false
                }
                this.categoryId = this.newCategoryId;
                this.flashData()
            },
            // 选中
            onSelect(item){
                const callBack = this.$_.cloneDeepWith(this.callBack)

                // 编辑游戏替换素材
                if(callBack){
                    let operationQueue = [
                        {
                            operation: callBack.operation,
                            path: callBack.path,
                            data: `${item.url}`
                        }
                    ]
                    this.setOperationQueue(operationQueue)
                    return false
                }
                this.$emit('onSelect', item)
            },
            onPage(page){
                this.pageConfig.page = page
                this.flashData()
            },
            async onMaterialItem(item, style){
                console.log('onMaterialItem==>', item, style)
                const isTemplate = ['template'].includes(this.type)
                // 游戏环节判断是否支持添加
                if(!isTemplate && !this.isCocos && this.menusData.lessonSelectedConfig?.type === 'game' && this.type!=='game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(!isTemplate && this.type!=='game' && !this.isCocos && this.menusData.lessonSelectedConfig?.type === 'html'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                // 如果是回调 则直接回调选中内容，关闭弹窗
                if (this.isCallBack) {
                    let newItem = item
                    if (newItem.sort === 'animation') {
                        newItem.url = JSON.stringify(newItem)
                    }
                    this.$emit('success', newItem)
                    return false
                }
                let isClose = true // 是否关闭更多弹窗
                const gameScenes = 'gameScenes'
                let fn = async ()=>{
                    let obj={id:item.id,clientsId:this.$store.state.initConfig.school_id};
                    const res = (this.isPlat)?await ResultServer.getResourceShopDetail(obj):await ResultServer.getResourceDetail(obj);
                    let data = res.data.attributes

                    let menusData = this.$store.state.menusData
                    let curBlockForms = this.$store.state.menusData.blocksForm
                    let copyedBlockForms = data.h5_remote.blocksForm || []
                    // 更新下unique
                    copyedBlockForms = this.$utils.addUniqueByArr({data: copyedBlockForms})
                    const templateData = this.$_.cloneDeepWith(copyedBlockForms)

                    // let blockForms = curBlockForms.concat(copyedBlockForms)
                    let blockForms = curBlockForms
                    Array.prototype.push.apply(blockForms, copyedBlockForms)
                    menusData.blocksForm = blockForms

                    const newData = this.$utils.one2TwoTree({data: this.$_.cloneDeepWith(menusData)})
                    menusData = newData.menusData

                    // 获取实际映射的ids列表
                    const {menusIds} = this.$utils.one2TwoTree({data: {...menusData, blocksForm: this.$_.cloneDeepWith(templateData)}, ids: this.menusDataIds})
                    this.$store.state.menusDataIds = {...this.$store.state.menusDataIds, ...menusIds}


                    // TODO 合并课件
                    const operation = [
                        {data:templateData,operation: 'merge'}
                    ]
                    $eventBus.$emit('__save__',true,null, operation)
                    console.log('操作==>合并课件m', operation)

                    // 如果菜单未选中，默认选中第一个场景第一个课件
                    if(!menusData.blocksSelected || !menusData.lessonSelected || menusData.lessonSelected === '0/0') {
                        menusData.blocksSelected = this.$utils.getFirstMenu({data: menusData.blocksForm});
                        let node = this.$utils.curSelectedNode({data: menusData.blocksForm, unique: menusData.blocksSelected})
                        if(node && node.children && node.children.length){
                            menusData.lessonSelected = node.children[0].unique
                        } else {
                            menusData.lessonSelected = ''
                        }
                    }

                    let curH5Original = this.$store.state.urlMap
                    let copyH5Original = data.h5_remote.urlMap || []
                    // let h5_original = curH5Original.concat(copyH5Original)
                    let h5_original = curH5Original
                    Array.prototype.push.apply(h5_original, copyH5Original)


                    this.$store.dispatch('setMenusData', this.$_.cloneDeepWith(menusData))
                    this.$store.dispatch('setNewUrlMap', this.$_.cloneDeepWith(h5_original))

                    this.$emit('success')

                }
                // 模版替换
                if(['template'].includes(this.type)){
                    this.isWarnInfo = true
                    this.fnNext = fn
                    // this.$confirm(`添加模版到课件, 是否继续?`, '提示', {
                    //     confirmButtonText: '确定',
                    //     cancelButtonText: '取消',
                    //     type: 'warning'
                    // }).then(() => {
                    //     fn()
                    // }).catch(() => {
                    // });
                    // console.log(item)
                    // let data = item.attributes
                    // this.$store.dispatch('setMenusData',data.h5_remote)
                    // this.$store.dispatch('setNewUrlMap',data.h5_remote.urlMap)
                    // this.$emit('success')
                    return false;
                }

                console.log('选中资源==>', this.type, item)

                // 向cocos通知 添加资源
                /**
                 game: 游戏
                 resources: 资源
                 shop-resources: 公共资源（资源商城）
                 * */
                let type = 'resources'
                if(this.isTypeTwo) type = 'shop-resources'
                if(this.type === 'game') type = 'game'
                if(this.type === gameScenes) type = gameScenes

                let md5 = this.$md5(type+item.id)

                let newUrl = item.url
                let newItem = {}
                if(['animation'].includes(this.type)){
                    newUrl = item.attributes.resources.url
                    let obj = {} // this.$utils.getObjByArr({data: item.attributes.form_data})
                    // 获取最新的表单地址 如果存在form_id
                    if(item.attributes.form_id){
                        const id = item.attributes.form_id
                        const res = await CommonServer.default.getFormDetail({ id })
                        // 获取 表单模版
                        obj = this.$utils.getObjByArr({data: this.$utils.getArrByDiy({ obj: res.data.options })})
                        console.log('获取最新表单模版==>', obj, res)
                    }
                    newItem = Object.assign({}, newItem, obj)
                    newItem.name = item.name
                    if(item.attributes.background_audio) newItem.background_audio = item.attributes.background_audio
                    if(item.attributes.background_img) newItem.background_img = item.attributes.background_img
                    if(['cocos', 'flash'].includes(item.attributes.type)){
                        newItem.type = item.attributes.type
                    }
                    // 动画更多配置
                    let list = item.bind_list
                    if(Array.isArray(item.bind_list)){
                        list = list.map(v=>{
                            return this.getMoreAnimation(v)
                        })
                    }
                    newItem.list = list
                }
                // 游戏的话，通过表单id 获取表单真实配置
                let theme
                if(['game', 'tools'].includes(this.type)){
                    let resCommon = null
                    let resQuestion = null
                    let resScenes = null
                    if (item.form_id_common) resCommon = await CommonServer.default.getFormDetail({id:item.form_id_common})
                    if (item.form_id_question) resQuestion = await CommonServer.default.getFormDetail({id:item.form_id_question})
                    if (item.form_id_scenes) resScenes = await CommonServer.default.getFormDetail({id:item.form_id_scenes})
                    console.log('youxi==>', resCommon, resQuestion, resScenes)
                    newItem.name = item.alias || item.name
                    newItem.mark = item.mark
                    newItem.question_type = item.question_type
                    newItem.is_double_teacher = item.is_double_teacher
                    newItem.is_online = item.is_online
                    newItem.is_offline = item.is_offline
                    theme = {background: {url: '', type: 'image'}}

                    if(['game'].includes(this.type))newItem['cocosGameBackgroundImage'] = item.url || item.cover

                    if(resCommon) {
                        const config_common_original = this.$utils.getArrByDiy({obj: resCommon.data.options})
                        newItem.config_common = this.$utils.getObjByArr({data: config_common_original})

                        // 特殊处理，如果通用配置中存在 rawConfig 就将其系列化
                        if(newItem.config_common.rawConfig && typeof newItem.config_common.rawConfig === 'string') {
                            newItem.config_common.rawConfig = JSON.parse(newItem.config_common.rawConfig)
                        }

                        // 将场景配置直接复合到默认游戏配置中
                        if(newItem.config_common[`rawConfig-${item.form_id_scenes}`]){
                            newItem.config_common = {rawConfig: newItem.config_common[`rawConfig-${item.form_id_scenes}`]}
                        }
                    }
                    if(resQuestion) {
                        const config_question_original = this.$utils.getArrByDiy({obj: resQuestion.data.options})
                        newItem.config_question = this.$utils.getObjByArr({data: config_question_original})
                    }
                    if(resScenes) {
                        const config_scenes_original = this.$utils.getArrByDiy({obj: resScenes.data.options})
                        newItem.config_scenes = {name: resScenes.data.name, id: resScenes.data.id, type: 'gameScenes' }
                        newItem.config_scenes.config = this.$utils.getObjByArr({data: config_scenes_original})
                    }
                    newItem.form_category_id_scenes = item.form_category_id_scenes
                    newItem.md5 = md5
                    // newUrl = item.attributes.resources.url
                }
                // debugger
                const callBack = this.$_.cloneDeepWith(this.callBack)

                // 编辑游戏替换素材
                if(callBack && callBack.id>-1){
                    // 约定cocos 发起编辑游戏配置
                    // 修改资源路径 和 名称
                    const operationQueue = [
                        {
                            id: callBack.id,
                            operation: callBack.operation,
                            path: callBack.path + '/value',
                            data: item.url
                        },
                        {
                            id: callBack.id,
                            operation: callBack.operation,
                            path: callBack.path + '/name',
                            data: item.name
                        }
                    ]
                    this.setOperationQueue(operationQueue)
                    isClose && this.$emit('success')
                    return false
                }

                // 默认场景设置
                let obj = {}
                if(this.type === 'scenes'){
                    this.setDefaultScene(item.attributes.options, md5)
                }else {
                    let cocosType = this.isEdit?'EditResource':'AddResource'
                    if(this.type === gameScenes || this.type === 'image'){

                        // 如果是图片 回调通知cocos编辑游戏
                        if(this.type === 'image' && this.callBack) {
                            newItem = {
                                [`${this.callBack.flag}`]: item.url,
                                [`${this.callBack.flag}Name`]: item.name,
                                [`${this.callBack.flag}Visible`]: true
                            }
                            const operationQueue = [
                                {
                                    operation: this.callBack.operation,
                                    path: this.callBack.path + `/${this.callBack.flag}`,
                                    data: newItem[`${this.callBack.flag}`]
                                },
                                {
                                    operation: this.callBack.operation,
                                    path: this.callBack.path + `/${this.callBack.flag}Name`,
                                    data: newItem[`${this.callBack.flag}Name`]
                                },
                                {
                                    operation: this.callBack.operation,
                                    path: this.callBack.path + `/${this.callBack.flag}Visible`,
                                    data: newItem[`${this.callBack.flag}Visible`]
                                },
                            ]
                            this.setOperationQueue(operationQueue)
                            isClose && this.$emit('success')
                            return false
                        }

                        newItem = {
                            categoryId: item.category_id,
                            name: item.name,
                            // id: item.id,
                            config: this.$utils.getObjByArr({data:this.$utils.getArrByDiy({obj:item.options})}),
                            cocosGameBackgroundImage: item.url || item.cover
                        }

                        // 如果是背景图片 则直接给到背景配置
                        if(['background'].includes(style)){
                            newItem = {
                                type: style,
                                url: item.url || item.cover
                            }
                        }

                        // 约定cocos 发起编辑游戏配置
                        if (this.callBack) {
                            const operationQueue = [
                                {
                                    operation: this.callBack.operation,
                                    path: this.callBack.path,
                                    data: newItem
                                }
                            ]
                            this.setOperationQueue(operationQueue)
                            isClose && this.$emit('success')
                            return false
                        }

                    }

                    if(this.type === 'game'){
                        const unique1 = Math.random()
                        obj = { theme, config: newItem, type: style || this.type, unique: unique1}

                        this.menusDataIds[unique1] = this.$_.cloneDeepWith(obj)

                        // 先保存一次
                        let unique = Math.random()
                        this.$store.state.addGameTempObj = {unique, data:this.menusDataIds[unique1]}
                        delete obj.config

                        // 添加游戏提示支持类型  
                        const {is_double_teacher, is_offline, is_online , is_exercise} = item
                        const arr = []
                        if(is_offline) arr.push('线下')
                        if(is_online) arr.push('线上')
                        if(is_double_teacher) arr.push('答题器')
                        if(is_exercise) arr.push('课后')
                        const str = `支持场景有：${arr.join('、')}课程`
                        if(arr && arr.length){
                            this.$message.success(str)
                        }

                        this.$toCocosMessage({type: 'SaveConfig', value: {flag: {type: 'addGame', unique}}})
                        this.$emit('success')
                    } else if(this.type === 'tools') {
                        obj = {config: newItem, type: this.type}
                        this.$toCocosMessage({type: 'AddResource', value: obj})
                        this.$emit('success')
                    } else {
                        // 如果是添加视频，提示视频弹窗
                        if(this.type === 'video' && style !== 'backgroundVideo') $eventBus.$emit('showWarnInfo', this.$enums.warnInfo.addVideo)
                        obj={ ...newItem, type: newItem.type || style || this.type, url: newUrl,category_id: item.category_id};
                        this.$toCocosMessage({...this.curEditItem, type: cocosType,value: obj})

                        if(this.menusDataIds[this.menusData.lessonSelected] && ['background', 'backgroundVideo'].includes(style)) {
                            this.$store.state.waitBackgourndVideo = true
                            $eventBus.$emit('onFlashLesson', true, null)
                        }
                    }
                    // 如果是游戏场景
                    if(this.type === gameScenes) {
                        this.$emit('success')
                        return false
                    }
                }

                let url = ''
                if(['scenes', 'game', 'tools'].includes(this.type)){
                    // 游戏 使用type+id 生成对应md5
                    url = md5
                }else{
                    url = this.$utils.getAllMd5({data: newUrl})[0]
                }

                this.$store.dispatch('setUrlMap',{mark:'service-map-object', type, id: item.id,url})
                // 关闭更多窗体
                isClose && this.$emit('success')
            },
            // 获取动画的更多配置
            getMoreAnimation(item){
                let newUrl = item.url
                let newItem = {}
                newUrl = item.attributes.resources.url
                // newUrl = newUrl.replace('https','http')
                let obj = {} // this.$utils.getObjByArr({data: item.attributes.form_data})
                // 获取最新的表单地址 如果存在form_id
                if(item.attributes.form_data){

                    // TODO 实时拿最新的动画模版配置

                    // const id = item.attributes.form_id
                    // const res = await commonServer.default.getFormDetail({ id })
                    // 获取 表单模版
                    obj = this.$utils.getObjByArr({data: item.attributes.form_data})
                    console.log('获取最新表单模版==>', obj)
                }
                newItem = Object.assign({}, newItem, obj)
                newItem.name = item.name
                if(item.attributes.background_audio) newItem.background_audio = item.attributes.background_audio
                if(item.attributes.background_img) newItem.background_img = item.attributes.background_img
                if(['cocos', 'flash'].includes(item.attributes.type)){
                    newItem.type = item.attributes.type
                }
                return {...newItem, type: this.type, url: newUrl}
            },
            // 上传
            onMaterialItemAdd(){
                console.log('上传==>', this.type)
                this.isAdd = true
            },
            // 设为背景视频
            onBackground(item, type){
                console.log('设为背景视频==>2', item, type)
                $eventBus.$emit('showWarnInfo', this.$enums.warnInfo.addVideoBackground)
                this.onMaterialItem(item, type)
            },
            // 设置默认场景
            setDefaultScene(data, md5){
                let form = this.$store.state.menusData.blocksForm
                console.log('111==>', data, form, md5)

                // 1.将场景格式[{xx:xx},{yy:yy}] 改成 {xx:xx, yy:yy}
                // 2.递归遍历菜单配置，将默认场景图覆盖
                // 3.向cocos通知最新选中的课程配置
                let oldData = this.$utils.arr2Obj({arr: data})
                this.$utils.setDefaultTheme({data: form, oldData, md5})

                console.log('优化速度==>setDefaultScene')
                // 通知cocos侧刷新配置
                let node = this.menusDataIds[this.menusData.lessonSelected]// this.$utils.getObjByCurLesson({})
                console.log('优化速度setDefaultScene==>GetLessonConfig')
                console.log('retro=>向cocos发配置1')
                this.$store.dispatch('setIsBuilding', true)
                this.$toCocosMessage({type: 'GetLessonConfig',value: getRandomByObj(node)})
            },
            async onUpload (item) {
                const obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type,
                    categoryId: this.categoryId,
                    name: item.name,
                    attributes: {
                        remotepath: item.url.split('.com/')[1],
                        md5: item.md5
                    }
                }
                try {
                    const res = await CommonServer.default[this.isTypeTwo ? this.apiConfig.addResourceTwo : this.apiConfig.addResourceOne](obj)
                    if (`${res.status_code}` === '200') {
                        this.flashData()
                    } else {
                        this.$message.error(res.errors)
                    }
                } catch (e) {
                    this.$message.error('添加失败' + e)
                }
            },
            // 导航变更
            changeNav (item, index, target) {
                console.log(item, index, target)
                switch (item.attr) {
                    case 'nav':
                        this.scenes_stage_id = this.selectNav[0].value
                        this.flashData()
                        break
                    default:
                }
            },
            // 获取导航筛选列表
            async getNavsList () {
                const obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    page_per: 1000,
                    sort: 'scenes_stage'
                }
                if (this.apiConfig.getResourceListOne) {
                    const res = await CommonServer.default[this.apiConfig.getResourceListOne](obj)
                    this.selectNav[0].options = res.items.map(v => {
                        return {
                            key: `${v.id}`,
                            value: v.name,
                            ...v
                        }
                    })
                    console.log('nav123==>', res)
                }
            },
            // 添加场景
            addScene () {
                if (!this.categoryId) {
                    this.$message.error('请先选择分类')
                    return false
                }
                this.isSceneShow = true
            },
            // 刷新列表
            flashData (newObj) {
                this.$nextTick(async()=>{
                    if(!['0', '1'].includes(this.$enums.enumTypeName[this.activeName]))return false;
                    this.loading = true
                    try {
                        let res = null
                        let newList=null
                        let obj = {
                            clientsId: this.$store.state.initConfig.school_id,
                            sort: this.type,
                            page: this.pageConfig.page,
                            // classType: this.$store.state.curClassType,
                            perPage: this.curPageSize,
                            is_online: this.isPlat?1:0,
                            is_push: this.isPlat?1:0
                        }
                        console.log("刷新列表",obj);
                        if(this.practiceBool() && this.type=="game"){//如果类型为：game 且 为课后练习，强制类型为：is_exercise
                            this.newFilterValue='is_exercise';
                        }

                        // 如果当前是场景，且存在导航id
                        if(['scenes'].includes(this.type) && this.navId>-1){
                            obj['scenesStageId'] = this.navId
                        }

                        if (this.newSearch) obj.search = this.newSearch
                        if (this.newFilterValue) obj.gameType = this.newFilterValue
                        if (Number.isInteger(this.scenes_stage_id)) obj.scenes_stage_id = this.scenes_stage_id
                        if (Number.isInteger(this.categoryId)) obj.categoryId = this.categoryId
                        if (this.type) obj.sort = this.type

                        if (newObj) obj = Object.assign({}, obj, newObj)
                        if(this.type === 'gameScenes'){
                            res = await FormServer.getFormList({ ...obj, categoryId: this.newCatalog, perPage: 21})
                            newList=res.items;
                        } else if(['game', 'tools'].includes(this.type)){
                            const enums = {
                                game: 'io',
                                tools: 'tools'
                            }
                            obj['gtype'] = enums[this.type]
                            //obj.page = 1
                            // 如果是游戏时，根据游戏场景拿到对应的游戏内容
                            res = await CommonServer.default[this.isTypeTwo ? this.apiConfig.getResourceListTwo : this.apiConfig.getResourceListOne](obj)
                            // console.log(res)
                            // 过滤出 游戏分类有数据的分类名
                            let newItems = res.items.filter(v=>{
                                if(['game'].includes(this.type)) return v.gtype==='io'
                                if(['tools'].includes(this.type)) return v.gtype==='tools'
                            })
                            //res.items = newItems
                            newList=newItems
                            
                            // debugger
                            let items = []
                            let resScene
                            for(let i = 0, len = newList.length; i < len; i++) {
                                resScene=newList[i].form_category_scenes_list;
                                //resScene.items.map(q => {
                                resScene.map(q => {
                                    items.push({
                                        ...newList[i],
                                        form_id_scenes: q.id,
                                        alias: `${newList[i].alias}-${q.name}`,
                                        url: this.getSceneImg(q.options)
                                    })
                                })
                            }
                            newList = items
                        } else {
                            // 如果是模版列表 分页为每页8条
                            if(['template'].includes(this.type)){
                                obj.perPage = 8
                            }

                            res = await CommonServer.default[this.isTypeTwo ? this.apiConfig.getResourceListTwo : this.apiConfig.getResourceListOne](obj)
                            
                            newList=res.items;
                            if(this.type === 'tools') {
                                let newItems = res.items.filter(v=>v.gtype==='tools')
                                newList=newItems;
                            }
                            console.log("this.typethis.typethis.type",this.type,res)
                        }
                        // 设置分页
                        this.pageConfig = {
                            page: parseInt(res.meta.current_page),
                            pageSize: parseInt(res.meta.per_page),
                            total: parseInt(res.meta.total)
                        }

                        // 获取资源数据
                        this.materialData = newList.map(v => {
                            const newObj = {}
                            if (v.attributes && v.attributes.resources && v.attributes.resources.url)newObj.url = v.attributes.resources.url
                            if (v.attributes && v.attributes.cover)newObj.url = v.attributes.cover
                            if (v.options && v.options.length > 2)newObj.url = this.getSceneImg(v.options)
                            return {
                                ...newObj,
                                ...v
                            }
                        })
                        // 获取音乐数据
                        if (this.type === 'audio') {
                            this.musicData = newList.map(v => {
                                const newObj = {}
                                if (v.attributes && v.attributes.resources && v.attributes.resources.url)newObj.url = v.attributes.resources.url
                                return {
                                    curTimeShow: '0:00', // 当前播放时间(分：秒)
                                    allTimeShow: '0:00', // 音频总时间展示
                                    play: false, // 是否播放
                                    curTime: 0,
                                    allTime: 0,
                                    playTime: 0, // 当前播放时间(秒)
                                    isKuaijin: false, // 是否正在快进
                                    ...newObj,
                                    ...v
                                }
                            })
                        }
                    } catch (e) {
                        this.loading = false
                        console.log('等待素材==>')
                    }

                    this.loading = false

                })
            },
            // 获取游戏场景封面
            getSceneImg (options) {
              let url = ''
              try {
                  let obj = JSON.parse(options)
                  obj.layout.map(v=>{
                      if(v.config && v.config[0].attr === 'cover') url = v.config[0].value
                  })
              } catch (e) {
                  console.log('获取游戏场景背景图失败==>', e)
              }
              return url
            },
            // 获取我的模版分类
            async getMyTempType () {
                const res = await CommonServer.default[this.apiConfig.getResourceCategoryTreeOne]({
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type,
                    parentId: 0
                })
                console.log('我的模版==>', res)
            },
            // 获取商城模版分类
            async getShopTempType () {
                const res = await CommonServer.default[this.apiConfig.getResourceCategoryTreeTwo]({
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type,
                    parentId: 0
                })
                console.log('商城模版==>', res)
            },
            onTypeSelectOne (data, node) {
                console.log('me==>', data, node)
                this.pageConfig.page = 1
                this.isTypeTwo = false
                this.categoryId = data.id
                this.defaultFormValue.categoryId = [`${data.id}`]
                this.flashData()
            },
            onTypeSelectTwo (data, node) {
                console.log('other==>', data, node)
                this.pageConfig.page = 1
                this.isTypeTwo = true
                this.categoryId = data.id
                this.defaultFormValue.categoryId = [`${data.id}`]
                this.flashData()
            },
            onSearch () {
                this.$emit('onSearch', this.search)
                console.log('search==>', this.search)
                this.flashData()
            },
            // 批量上传
            batchUpload () {
                this.uploadBatchFields = this.$_.cloneDeepWith(filedsBatch)

                // 设置表单是否平台 或 校区
                this.uploadBatchFields.map(v => {
                    if (['data'].includes(v.attr)) {
                        v.isPlat = this.isTypeTwo
                    }
                })

                const categoryIndex = this.$utils.getIndexByAttr({ attr: 'category_id', data: this.uploadBatchFields })
                this.uploadBatchFields[categoryIndex].options = this.$utils.getNewChilrens(this.batchData)
                // 设置当前批量上传的类型
                const dataIndex = this.$utils.getIndexByAttr({ attr: 'data', data: this.uploadBatchFields })
                this.uploadBatchFields[dataIndex].props.accept = this.$enums.fileEnums[this.type]
                this.isBatch = true
            },

            // 批量上传
            async onBatchUpload (newItem) {
                this.loading = true
                let item = newItem
                if (Array.isArray(item) ) {
                    item = this.$utils.getObjByArr({ data: newItem })
                }
                const categoryId = item.category_id ? item.category_id[item.category_id.length - 1] : ''
                const data = item.data.map(v => {
                    const remotepath = v.url.split('.com/')[1]
                    return {
                        name: v.name,
                        attributes: {
                            remotepath,
                            md5: this.$utils.getMd5(v.url)
                        }
                    }
                })
                const obj = {
                    clientsId: this.$store.state.initConfig.school_id,
                    sort: this.type,
                    categoryId,
                    is_online: true,
                    data
                }

                // console.log(obj)
                // debugger

                try {
                    const res = await CommonServer.default[
                        this.isTypeTwo
                            ? this.apiConfig.addBatchResourceTwo
                            : this.apiConfig.addBatchResourceOne
                        ](obj)
                    if (`${res.status_code}` === '200') {
                        // 1.关闭添加弹窗
                        // 2.刷新页面
                        this.$refs.materialItem && this.$refs.materialItem.closeBatch()
                        this.isBatch = false
                        this.flashData()
                    } else if (`${res.status_code}` === '422') {
                        this.$message.error(res.errors.name.toString())
                    } else {
                        this.$message.error(res)
                        console.log('错误自行处理==>', res)
                    }
                } catch (e) {
                    this.$message.error('批量添加失败' + e)
                }
                this.loading = false
            },
        }
    }
</script>

<style lang="scss" scoped>
.meterial-box{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    min-height: 496px;

    .audio-box{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 40px;
        margin-top: 24px;

        .radio-box{
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .audio-name{
            color: #FF7838;
            cursor: pointer;
        }
    }

    &.isWordAudio{
        flex-direction: column;

        .type-select-box{
            margin-left: 30px;
            margin-top: 0px;

            &:before{
                display: none;
            }
        }

        & /deep/ .music-box{
            margin-right: 30px;
        }

        .radio-box {
            /deep/ .el-radio{
                margin-right: 0px;
                margin-left: 10px;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner {
                border-color: #FF7838;
                background: white;
            }
            /deep/ .el-radio__input.is-checked + .el-radio__label{
                color: #FF7838;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner::after{
                transform: translate(-50%,-50%) scale(2);
                background-color: #FF7838;
            }
        }

        & /deep/ .el-tabs__nav {
            border-bottom: 1px solid #E4E7ED;
            margin-left: 40px;
            margin-top: 24px;
        }

        .type-box{
            /*position: static;*/

            /deep/ .el-tabs__active-bar.is-top{
                background-color: #FF7838 !important;
                bottom: -41px;
            }
        }

        /deep/ .el-tabs__nav-wrap::after{
            background-color: white;
        }

        & /deep/ .voice-box{
            margin-left: 40px;

            .type-select .item{
                width: 100px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                border: 1px solid #DCDFE6;
                border-right: none;

                &:first-child{
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                }

                &:last-child{
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    border-right: 1px solid #DCDFE6;
                }

                &:hover,&.active{
                    background-color: white;
                    color: #FF7838;
                    border-color: #FF7838;

                    &+p{
                        border-left-color: #ffac01;
                    }
                }
            }
            .list-select-box{
                margin-left: -9px;
            }
        }
    }

    .right-content{
        display: flex;
        flex-direction: row;
        width: 100%;
    }

    .title {
        position: absolute;
        top: 0px;
        left: 0px;
        line-height: 28px;
        font-size: 20px;
        color: white;
        background-color: #303133;
        width: 110px;
        height: 34px;
        padding-top: 25px;
        padding-bottom: 14px;
        text-align: center;
    }
    .type-box{
        position: absolute;
        top: 15px;
        left: 127px;
    }

    .scenes{
        margin-left: 0px;
        border-left: none;
    }

    .type-select-box{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-width: 160px;
        transition: all .2s linear;
        margin-top: 20px;
        max-width: 160px;
        position: relative;
        background-color: white;

        &:before{
            content: '';
            position: absolute;
            bottom: -73px;
            right: -1px;
            width: 1px;
            height: 73px;
            background-color: #f1f1f1;
            z-index: 10;
        }

        .name{
            color: white;
            padding: 2px 16px;
            background-color: #e7622e;
            border-radius: 20px;
            margin: 10px 0px;
            align-self: center;
        }
    }
}
</style>
